import { Component, Output, EventEmitter, ChangeDetectionStrategy, signal } from '@angular/core';

@Component({
  standalone: false,
  selector: 'fdb-custom-notification',
  templateUrl: './custom-notification.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./custom-notification.component.scss']
})
export class CustomNotificationComponent {

  @Output() public ignore: EventEmitter<any> = new EventEmitter();

  public message = signal('!Leere Message');

  public ignoreNotification(event: Event): void {
      event.preventDefault();
      this.ignore.emit();
  }

}
